export const WORKBENCH_EYE_COLORS = [
  '#E4322A',
  '#F0850F',
  '#F2C005',
  '#2AA84A',
  '#12A5B8',
  '#2563EB',
  '#8B3DD6'
]

export const IOT_SYSTEM_DESIGN_NAME = '平台构建师'

// 方案设计猫：图纸识别工作流以 Windows 绿色应用包分发（内嵌 Python + 本地启动器），
// 在用户本机运行并直接扫描本机图纸，不再提供云端上传入口。
// 下载地址默认走平台同域 /downloads/（构建时把 zip 放进 iot-front/public/downloads/），
// 临时指向别处用 VUE_APP_SOLUTION_DESIGN_DOWNLOAD 覆盖，不要在页面里再写死第二份地址。
export const SOLUTION_DESIGN_PATH = '/workbench/solution-design'
export const SOLUTION_DESIGN_DOWNLOAD_URL = process.env.VUE_APP_SOLUTION_DESIGN_DOWNLOAD || '/downloads/aimason-solution-design-windows-x64.zip'
export const SOLUTION_DESIGN_PACKAGE = {
  version: '1.4.1',
  platform: 'Windows 10/11 64 位'
}

export const WORKBENCH_SKILLS = [
  {
    id: 'solution-design',
    name: '方案设计',
    tagline: '有想法，我帮你变成方案。',
    actionLabel: '聊聊我的想法',
    description: '我会根据用户需求和设计图纸，梳理项目范围、设备能力与控制目标，建立完整的项目设备台账；再以设备台账为基础自动适配场景化套件，形成控制系统架构、场景配置、设备选型与数量、接口边界及设备清单，为后续报价、深化设计、采购、施工和交付提供统一方案依据。',
    illustration: 'solution',
    status: 'live',
    needs: ['选型', 'bom']
  },
  {
    id: 'iot-system-design',
    name: IOT_SYSTEM_DESIGN_NAME,
    tagline: '给我 CAD 图纸，我帮你建模、搭平台。',
    actionLabel: '构建我的平台',
    description: '我负责将CAD/PDF图纸、设备表、点表等原始资料转化为平台可直接使用的深化设计成果。通过校核图层、空间、设备、点位及命名关系，形成符合平台建模规范的CAD底图、设备与点位台账、系统拓扑和接口清单，为3D模型转换、设备绑定、施工调试及平台部署提供统一依据。',
    illustration: 'system',
    status: 'live',
    needs: ['iot', 'architecture', 'topology', '点表']
  },
  {
    id: 'protocol-debug',
    name: 'Modbus 专家',
    tagline: '设备接入有问题，来找我。',
    actionLabel: '聊聊我的设备',
    description: '我专注于各类Modbus设备通信协议解析与智能化接入，覆盖Modbus RTU及RS485通信场景。针对资料缺失、协议不明、寄存器未知、设备无法联网等问题，通过报文采集、功能码测试、寄存器分析、CRC校验与实机验证，梳理设备状态数据和控制指令，形成完整通信点表及技术文档。可将空调、传感器、仪表、变频器、控制器等传统设备接入SIU、SCU、物联网平台系统，实现数据监测、远程控制、报警联动及可视化管理，为设备数字化升级提供可靠方案。',
    illustration: 'modbus',
    status: 'live',
    needs: ['serial', 'modbus', '485']
  },
  {
    id: 'energy-expert',
    name: '节能专家',
    tagline: '想让设备更省能，来找我。',
    actionLabel: '分析节能方向',
    description: '我基于平台持续记录的能耗、设备运行、环境与时段数据开展节能诊断，估算项目能耗基线，识别无效运行、控制参数不合理、负荷不匹配和设备效率下降等问题，判断项目是否具备节能潜力，并给出措施优先级、预估节能量及验证建议；当数据不足时，会明确说明假设条件和估算区间。',
    illustration: 'energy',
    status: 'soon',
    needs: ['energy']
  },
  {
    id: 'data-analyst',
    name: '数据分析师',
    tagline: '看不懂运行数据，我帮你分析。',
    actionLabel: '看懂我的数据',
    description: '我根据平台记录的设备、点位、告警、能耗和控制数据，完成数据质量检查、指标口径梳理、趋势对比、相关性分析与异常识别，定位设备运行和控制策略中的问题，形成清晰的图表、分析报告和可执行的改进意见，为运行优化、故障排查、节能管理及后续决策提供数据依据。',
    illustration: 'analytics',
    status: 'soon',
    needs: ['data']
  },
  {
    id: 'space-intelligence-design',
    name: '空间智能设计师',
    tagline: '选择生产设备，添加空间智能任务。',
    actionLabel: '生产设备',
    description: '我专注于SIU空间智能程序的设计与维护，面向办公室、客房、会议室等空间内的风机盘管、照明、门锁、窗帘及环境传感器，梳理点位映射、控制逻辑、场景联动和异常处理，形成可部署的SIU程序、策略清单及测试说明，让空间在舒适、节能与使用体验之间实现协调运行。',
    illustration: 'space',
    status: 'live',
    needs: ['space', 'scene', 'sensor', 'strategy']
  },
  {
    id: 'device-intelligence-design',
    name: '设备智能设计师',
    tagline: '选择生产设备，添加设备智能任务。',
    actionLabel: '生产设备',
    description: '我专注于SCU设备智能程序的设计与维护，主要服务冷热源机组、空调机组、水泵及其他大型机电设备。通过梳理设备协议、I/O点位、运行状态、控制顺序和安全联锁，形成SCU点位模型、采集控制程序、告警保护逻辑及调试测试方案，帮助复杂设备稳定接入平台并实现智能运行。',
    illustration: 'device',
    status: 'live',
    needs: ['device', 'point', 'edge', 'control']
  }
]

export const WORKBENCH_PROVIDERS = [
  {
    id: 'claude',
    name: 'Claude',
    vendor: 'Anthropic',
    models: ['claude-opus-4-8', 'claude-sonnet-5', 'claude-haiku-4-5'],
    toolCalling: true
  },
  {
    id: 'openai',
    name: 'OpenAI GPT',
    vendor: 'OpenAI',
    models: ['gpt-4o', 'gpt-4o-mini'],
    toolCalling: true
  },
  {
    id: 'qwen',
    name: '通义千问',
    vendor: '阿里云 · DashScope',
    models: ['qwen-max', 'qwen-plus', 'qwen-turbo'],
    toolCalling: true
  },
  {
    id: 'doubao',
    name: '豆包',
    vendor: '字节 · 火山方舟',
    models: ['doubao-pro-32k', 'doubao-lite-32k'],
    toolCalling: true
  },
  {
    id: 'deepseek',
    name: 'DeepSeek',
    vendor: '深度求索',
    models: ['deepseek-chat', 'deepseek-reasoner'],
    toolCalling: true
  },
  {
    id: 'kimi',
    name: 'Kimi',
    vendor: '月之暗面 · Moonshot',
    models: ['moonshot-v1-32k', 'moonshot-v1-8k'],
    toolCalling: true
  },
  {
    id: 'glm',
    name: '智谱 GLM',
    vendor: '智谱 AI',
    models: ['glm-4-plus', 'glm-4'],
    toolCalling: true
  },
  {
    id: 'local',
    name: '本地模型',
    vendor: 'Ollama / vLLM',
    models: ['qwen2.5:14b', 'llama3.1:8b'],
    toolCalling: 'partial'
  }
]

export function workbenchProviderById(id) {
  return WORKBENCH_PROVIDERS.find(provider => provider.id === id) || WORKBENCH_PROVIDERS[0]
}
